// INFINITE SCROLL
export const SCROLL_LOAD_MORE_RATIO = 0.99;
export const DEFAULT_SKELETON_ON_LOADING = 15;

// TABLE
export const DEFAULT_PER_PAGE = 10;
export const ALERT_TABLE_PER_PAGE = 6;
export const TABLE_COLUMN_DEFAULT_WIDTH = 150;

// PILL GROUP
export const PILL_GROUP_GAP_PX = 8;
export const PILL_GROUP_ROUNDING_BUFFER_PX = 1;

// PAGE LAYOUT
export const PAGE_GUTTER_CLASS = "mx-6 mt-4.5 mb-6 md:mt-6";

// CARD
export const CARD_IMAGE_HEIGHT_CLASS = "h-[139px]";
